<template>
  <div class="product-card">
    <slot name="product-title"></slot>
    <span class="subtitle">{{ productData.subtitle }}</span>
    <div class="card-shade">
      <div class="product-gallery">
        <div v-if="global.screenWidth > 998">
          <svg width="37" height="37" viewBox="0 0 37 37" xmlns="http://www.w3.org/2000/svg" v-bind:class="'magnification'" @click="showModal()" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M26.577 8.192c4.598 4.598 5.032 11.782 1.302 16.868.039.032.076.067.112.103l6.364 6.364-2.828 2.828-6.364-6.364-.103-.112c-5.086 3.73-12.27 3.296-16.868-1.302-5.076-5.077-5.076-13.308 0-18.385 5.077-5.076 13.308-5.076 18.385 0zm-15.512 2.873a8.938 8.938 0 1012.64 12.64 8.938 8.938 0 00-12.64-12.64zM18.188 13v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2z" fill="#BCBCBC" fill-rule="evenodd"/></svg>
        </div>
        <ImageGallery
          :data="productData.images"
          :idString="`productcard-${productCardId}`"
          :disableShadow="true"
        />
      </div>
      <div class="product-description" :id="`desc-${modalId}`">
        <div class="desc-sep" />
        <div class="product-description-inner" :id="`measure-${modalId}`">
          <span class="description-title">Description:</span>
          <slot name="description" class="description"></slot>
          <span v-if="productDetailsExist" class="description-title"
            >Product Details:</span
          >
          <slot
            v-if="productDetailsExist"
            name="product-details"
            class="description"
          ></slot>
        </div>
      </div>
    </div>
    <div class="product-buttons">
      <div v-if="price" class="button gray-button">
        <span>{{ isExpanded ? "Less Details" : "$49.99" }}</span>
      </div>
      <div
        v-else
        class="button gray-button"
        @click="toggleDescription(!isExpanded)"
      >
        <span>{{ isExpanded ? "Less Details" : "More Details" }}</span>
      </div>

      <a
        v-if="
          !productData.productSaleInfo ||
          productData.productSaleInfo.productAvailable
        "
        class="button red-button"
        :href="
          productData.buyurl
            ? productData.buyurl
            : 'https://www.ivyshop.net/pages/respect'
        "
        target="_blank"
        v-ePitchTracking="{
          site: currentRouteName,
          category: 'Link - Product',
          label: productData.title,
        }"
      >
        <span v-if="!spanish">Buy Now</span>
        <span v-if="spanish">COMPRA AHORA</span>
        <!-- <span v-else>Buy Now</span> -->
      </a>
      <a v-else class="button red-button">
        <span>{{ productData && productData.productSaleInfo.textDate }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import ImageGallery from "@/components/global/ImageGallery";
import { TweenLite } from "gsap/dist/gsap";
import { mapState, mapActions } from "vuex";
export default {
  name: "ProductCard",
  props: {
    productCardId: {
      type: Number,
      required: true,
    },
    productDetailsExist: {
      type: Boolean,
      required: false,
    },
    productData: {
      type: Object,
      required: true,
      default: () => ({
        title: "",
        subtitle: "",
        images: [],
        highResImages: [],
        buyurl: "",
        productSaleInfo: {
          productAvailable: true,
          textDate: null,
        },
      }),
    },
    price: {
      type: Boolean,
      required: false,
    },
    spanish: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      modalId: `productCardModal${this.productCardId}`,
      isExpanded: false,
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    toggleDescription(nextState) {
      this.isExpanded = nextState;
      const ele = document.getElementById(`desc-${this.modalId}`);
      const measureEle = document.getElementById(`measure-${this.modalId}`);
      if (!ele || !measureEle) return;
      TweenLite.to(ele, 0.5, {
        height: nextState ? measureEle.scrollHeight : 0,
      });
    },
    showModal() {
      this.setGalleryData(this.productData);
    },
    handleResize() {
      if (this.isExpanded) {
        this.toggleDescription(true);
      }
    },
    ...mapActions(["setGalleryData"]),
  },
  components: {
    ImageGallery,
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    ...mapState(["global"]),
  },
};
</script>


<style lang="scss" scoped>
.product-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: fit-content;

  .product-gallery {
    position: relative;
    width: 100%;
    background: #fff;
  }
  .magnification {
    position: absolute;
    top: 11px;
    right: 9.5px;
    height: 37px;
    width: 37px;
    z-index: 99;
    outline: none;
    &:hover {
      cursor: pointer;
      path {
        fill: #ce0e2d;
      }
    }
  }
  .card-shade {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #ffffff;
    box-shadow: 0 6px 30px 5px rgba(0, 0, 0, 0.1);
  }
  .desc-sep {
    height: 1px;
    width: 100%;
    background: #eaeaea;
  }
  .product-description-inner {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 11px;
    padding-bottom: 34px;
    padding-left: 27px;
    padding-right: 27px;
  }
  .product-buttons {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    .button {
      width: 50%;
      padding: 0;
    }
  }
  .product-description {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 0;
    overflow: hidden;
    background: #fff;
  }
  .description {
    font-family: AvenirNext-Regular;
    font-size: 14px;
    color: #3e3e3e;
    line-height: 23px;
    width: 100%;
  }
  .description-title {
    font-family: Poppins-Bold;
    font-size: 16px;
    color: #1a1a1a;
    letter-spacing: 0;
    text-align: left;
    line-height: 22px;
    margin-top: 20px;
    margin-bottom: 13px;
  }
  .subtitle {
    font-family: AvenirNext-Regular;
    font-size: 14px;
    color: #3e3e3e;
    text-align: center;
    line-height: 23px;
    margin-bottom: 28px;
    @media (max-width: 1200px) and (min-width: $lg) {
      height: 46px;
    }
  }
  ul {
    transform: translateX(-20px);
  }
  p {
    margin-bottom: 20px;
    text-align: start !important;

    &:last-child {
      margin-bottom: 0;
    }
  }
  h5 {
    font-family: Poppins-Bold;
    font-size: 26px;
    color: #1a1a1a;
    letter-spacing: 0;
    text-align: center;
    line-height: 28px;
    width: 100%;
    margin-bottom: 16px;
    // @media (min-width: $xl) {
    //   br {
    //     display: none;
    //   }
    // }
    @media (max-width: $lg) and (min-width: 323px) {
      br {
        display: none;
      }
    }
    @media (max-width: 700px) {
      margin-bottom: 4px;
    }
  }
}
</style>

